import { isPermissionGranted } from 'src/utils/permissions/isPermissionGranted';
import { TMenuNode } from '../components/types';
import { READ_PERMISSION } from 'src/constants/permissions';
import { TPermissions } from 'src/interfaces/user';
import { TAccessLevel } from 'src/components/access';

/**
 * Check if the item can be seen
 *
 * @param {TMenuNode} item
 * @return {*}  {boolean}
 */
export const canSeeItem = ({
    item,
    permissions = {},
    accessLevel,
}: {
    item: TMenuNode;
    permissions?: TPermissions;
    accessLevel?: TAccessLevel;
}): boolean => {
    if ('path' in item) {
        if (
            item.accessLevels?.length &&
            (!accessLevel || !item.accessLevels.includes(accessLevel))
        )
            return false;

        if ('permission' in item && item.permission) {
            return isPermissionGranted({
                permissions: permissions,
                permission: item.permission,
                crud: READ_PERMISSION,
            });
        }
        return true;
    }

    if ('items' in item)
        return item.items.some((child) =>
            canSeeItem({ item: child, permissions, accessLevel })
        );

    return false;
};
